<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="18" :md="14">
        <div class="news">
          <h1>
            第五届清华校友三创大赛长三角赛区复赛圆满结束，“一滴血评估女性卵巢功能”晋级全国总决赛！
          </h1>
          <p>
              6月20日，第五届清华校友创意创新创业大赛长三角赛区复赛在创新之都合肥成功举行。本届清华校友三创大赛长三角赛区复赛由清华校友总会、
            安徽省科技厅指导，合肥市科技局、合肥经开区管委会、清华大学安徽校友会主办，江苏省清华大学校友会、清华大学上海校友会、清华大学浙江校友会、
            清华大学南京校友会、清华大学苏州校友会、清华大学扬州校友会、宁波清华大学校友会、清华大学徐州校友会、清华大学淮安校友会、镇海区清华校友创业创新基地联合主办，
            合肥启迪科技城承办，清华大学合肥公共安全研究院、南艳湖机器人小镇协办。
          </p>
          <img src="@/assets/images/information/0625_1.jpg" alt="" />
          <p>
              第五届清华校友三创大赛长三角赛区比赛自2019年12月22日启动以来，得到了社会各界及各地政府部门的鼎力支持。大赛历时近6个月时间，共设立上海、浙江、合肥、
            南京、苏州、扬州、淮安7大赛点，6大赛道（TMT/AI/大数据/5G/区块链、集成电路、健康医疗、先进制造、人居环境、文创体育）118个优秀项目先后闪亮登场，最终73个校友项目进入复赛。
            不断汇集的清华创新创业力量，持续掀起长三角地区创新创业浪潮。
          </p>
          <img src="@/assets/images/information/0625_2.jpg" alt="" />
          <h2>项目路演，“硬核科技”集结</h2>
          <p>
              大赛开幕式结束后，各参赛校友进行了精彩的项目路演。7大赛点、6大赛道、73个参赛项目可谓“群英荟萃”。这其中有极具“硬核科技”实力的“可重构网络安全芯片”项目、
            “柔性电子—可拉伸电池与弹性导线”项目；关注人类健康的“谷物多肽—人类生命健康的活力源”项目；关注人类生存环境的“纳米硅酸盐改性技术在建筑防水和修缮行业中的研发和产业化”项目；
            关注新能源应用的“轻量化动力锂电池结构件”项目；聚焦文化产业发展的“中国城市文创IP矩阵创建与运营”……
          </p>
          <img src="@/assets/images/information/0625_3.jpg" alt="" />
          <h2>颁奖典礼，“一滴血评估女性卵巢功能”等42个项目晋级全国总决赛</h2>
          <p>
              本届大赛采取8分钟项目路演+5分钟评审专家提问的形式进行，评委打分的平均值决定每个项目的最终名次。经过激烈的角逐，大赛分别评选出TMT/AI/大数据/5G/区块链、集成电路、
            健康医疗、先进制造、人居环境、文创体育6大赛道的一、二、三等奖。“汇智清华
            创新中国”第五届清华校友三创大赛长三角赛区复赛圆满结束。预祝各晋级校友项目在全国总决赛中能够再创佳绩，
            取得新的突破！希望校友们的三创事业直挂云帆，乘风破浪！
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Cooperation",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.news {
  margin-top: 90px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  img {
    width: 380px;
    height: auto;
  }
  .imgtxt {
    text-align: center;
    margin-top: 5px;
  }
  p {
    line-height: 28px;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  h1,
  h2 {
    margin-top: 20px;
  }
}
</style>
